import React, { createContext, useContext, useEffect, useState } from 'react';

// 创建滚动上下文
const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 70) {
        setIsScrolled(true);
        console.log(isScrolled,'isScrolled-12')
      } else {
        setIsScrolled(false);
        console.log(isScrolled,'isScrolled-15')
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={isScrolled}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScroll = () => {
console.log(ScrollContext,'ScrollContext-isScrolled-32')
  return useContext(ScrollContext);
};
